import React, { useEffect, useState } from 'react'
import { useInput } from 'Helpers/'
import Input from 'Components/shared/Input'
import { Button } from 'Components/shared/Button'

import { Flex } from 'lese'
import { SelectIcon } from 'Components/shared/Select'
import CustomLinkService from 'Services/customlinks'
import { toast } from 'react-toastify'
import { toastWithErrorMessage } from 'Helpers/toast'

// TODO: The original one had horrible icon to value reference. need to fix that
const icons = [
  { text: 'FAQ', value: 13 },
  { text: 'Shopping', value: 1 },
  { text: 'Website', value: 2 },
  { text: 'Facebook', value: 3 },
  { text: 'Twitter', value: 4 },
  { text: 'Merchandise', value: 5 },
  { text: 'Tag', value: 6 },
  { text: 'Settings', value: 7 },
  { text: 'Diamond', value: 8 },
  { text: 'Pinterest', value: 9 },
  { text: 'YouTube', value: 10 },
  { text: 'Instagram', value: 11 },
  { text: 'News', value: 12 },
  { text: 'Calendar', value: 14 },
  { text: 'News', value: 15 },
  { text: 'Maps', value: 16 },
  { text: 'Videos', value: 17 },
  { text: 'Merchandise', value: 18 },
  { text: 'Signal', value: 19 },
  { text: 'Team', value: 20 }
]

export default ({ selectedClub, updateLinks, customLinks }) => {
  const [club, setClub] = useState()
  const [icon, setIcon] = useState(13)

  const shortNameHook = useInput()
  const longNameHook = useInput()
  const urlHook = useInput()

  useEffect(async () => {
    if (!selectedClub) return

    setClub(selectedClub)
  })

  const createCustomLink = async () => {
    if (!shortNameHook.value || !longNameHook.value || !urlHook.value) {
      toast.error('Please fill out all fields for the custom link.')
      return
    }

    const data = {
      clubimpact_id: club.id,
      icon: parseInt(icon, 10),
      shortname: shortNameHook.value,
      longname: longNameHook.value,
      url: urlHook.value,
      deleted: 0
    }

    await CustomLinkService.create({ data })
      .then(linkData => {
        const link = linkData.data
        const cl = customLinks.map(l => l.id)
        cl.push(link.id)
        updateLinks({ ids: cl })
      })
      .catch(() => {
        toastWithErrorMessage('Something went wrong when saving the custom link.')
      })
  }

  return (
    <Flex row separation="24px" yAlign="center">
      <SelectIcon
        onChange={e => {
          setIcon(e.newIndex)
        }}
        options={icons}
        defaultIndex={13}
        height="15vh"
        width="125px"
      />
      {/* Icon */}
      <Input placeholder="Name" {...shortNameHook.bind} /> {/* Name */}
      <Input placeholder="Description" {...longNameHook.bind} /> {/* Description */}
      <Input placeholder="Link" {...urlHook.bind} /> {/* URL */}
      <Button onClick={createCustomLink}>Create</Button>
    </Flex>
  )
}
